import { render, staticRenderFns } from "./startInfo.vue?vue&type=template&id=f94a0b94&scoped=true&"
import script from "./startInfo.vue?vue&type=script&lang=js&"
export * from "./startInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94a0b94",
  null
  
)

export default component.exports